import { useLayoutEffect } from "react"
import { useEditor } from "./useEditor"
import { useResizeObserver } from "@/utils/useResizeObserver"

export const useObserveCanvasSize = () => {
	const editor = useEditor()
	const { observeRef, dimensions, element } = useResizeObserver()

	useLayoutEffect(() => {
		const container = element.current
		const isCanvasMounted = !!container?.querySelector("canvas")

		const updateCanvasSize = () => {
			editor.setCanvasSize(dimensions.clientWidth, dimensions.clientHeight)
		}

		if (!isCanvasMounted && container) {
			container.appendChild(editor.canvas as HTMLCanvasElement)

			if (editor.canvas instanceof HTMLCanvasElement) {
				editor.canvas.style.position = "absolute"
				editor.canvas.style.width = "100%"
				editor.canvas.style.height = "100%"
				editor.canvas.style.inset = "0"
			}

			updateCanvasSize()
		}

		updateCanvasSize()
	}, [dimensions.clientWidth, dimensions.clientHeight])

	return { observeRef, dimensions }
}
